module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--medium@2x-8e6213d80f88feeaea0d8fa9ffe23e01.jpg";